var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lb_bg",class:{ show: _vm.open }},[_c('div',{class:{ isPrice: _vm.isPrice },attrs:{"id":"lb"}},[_vm._t("default"),_c('img',{staticClass:"btn_close",attrs:{"src":require("@/assets/images/btn_close.png"),"alt":""},on:{"click":_vm.closeLb}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }